import React, {useEffect, useState} from 'react'
import CustomSelect from '../../core/customSelect'
import Input from '../../core/input'
import LargeSwitch from '../../core/switch/LargeSwitch'
import './index.scss'
import text from './text.json'
import Tooltip from '../../core/tooltip'
import PieProgressChart from '../pieProgressChart'
import {NewInfoIcon} from '../../../icons'
import TextHelper from '../../../utils/text'

const names = {
    interval_value: 'interval_value',
    interval_unit: 'interval_unit'
}

const IntervalSettings = ({
    isAdvancedEnabled,
    onChangeAdvancedSettings,
    onChangeFormValues,
    isIntervalSettingDisabled,
    values,
    intervalSelectOptions,
    intervalLabelText,
    intervalInfoText,
    intervalLimit,
    intervalUsage,
    menuPosition,
    isNewInfoIcon = false
}) => {
    const [modifiedSelectValue, setModifiedSelectValue] = useState(values.interval_unit)
    const pluralizedSelectValue = ({
        ...values.interval_unit,
        label: values.interval_unit.label + TextHelper.pluralize(Number(values.interval_value))
    })

    useEffect(() => {
        setModifiedSelectValue(pluralizedSelectValue)
    }, [values])

    return (
        <div className="advanced-field">
            <div className="advanced-checkbox-wrapper">
                {isIntervalSettingDisabled ? (
                    <Tooltip placement="top" content={text.usage_limit_exceeded} trigger="mouseenter">
                        <LargeSwitch
                            checked={false}
                            onChange={onChangeAdvancedSettings}
                            name="is_advanced"
                            disabled={isIntervalSettingDisabled}
                        />
                    </Tooltip>
                ) : (
                    <LargeSwitch
                        checked={isAdvancedEnabled}
                        onChange={onChangeAdvancedSettings}
                        name="is_advanced"
                    />
                )}
                <div className="advanced-checkbox-label">{text.use_advanced}</div>
            </div>

            <div className="advanced-interval-wrapper">
                <div className="advanced-interval-form-container">
                    <label>{intervalLabelText}</label>
                    <div className="advanced-interval-fields" id="advanced-interval-fields">
                        <span className='advanced-form-elements'>
                            <Input
                                type="number"
                                inputIsDisabled={!isAdvancedEnabled || isIntervalSettingDisabled}
                                value={values.interval_value}
                                onChange={(e) => onChangeFormValues(names.interval_value, e, false)}
                                name={names.interval_value}
                                minNumber="1"
                            />
                            <CustomSelect
                                isDisabled={!isAdvancedEnabled || isIntervalSettingDisabled}
                                onChange={(name, value) => onChangeFormValues(name, value, true)}
                                infoText={!isNewInfoIcon && intervalInfoText}
                                value={modifiedSelectValue}
                                name={names.interval_unit}
                                options={intervalSelectOptions}
                                menuPosition={menuPosition}
                            />
                        </span>
                        {isNewInfoIcon &&
                            <Tooltip content={intervalInfoText} trigger='mouseenter' placement='right'>
                                <NewInfoIcon width={20} height={20}/>
                            </Tooltip>}
                    </div>
                </div>
                <PieProgressChart
                    max={intervalLimit}
                    value={intervalUsage}
                    config={{
                        tooltip_text: text.usage_text,
                        label_text: text.usage
                    }}/>
            </div>
        </div>
    )
}

export default IntervalSettings
